import * as React from 'react';
import * as randomColor from 'randomcolor';
import IconAvatar from '../IconAvatar/IconAvatar';

const CompanyAvatar = ({ company, size = "64" }) => (
  <IconAvatar
    size={size}
    icon="briefcase"
    colour={randomColor({ seed: (company.id || 0) * 2000, luminosity: 'light' })}
  />
);

export default CompanyAvatar;
